export default "__VITE_ASSET__BxO47CVT__"